module.exports = __webpack_public_path__ + "img/measure.9141e618.svg";